// extracted by mini-css-extract-plugin
export default {"tab":"profile-tabs_tab__yah2Z"};